import React from 'react';

const LikeItemSkeleton = () => (
  <div className="flex items-center gap-3 px-3 sm:px-4 py-2 animate-pulse">
    {/* Profile Picture Skeleton */}
    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-200 rounded-full flex-shrink-0"></div>
    
    {/* Username Skeleton */}
    <div className="flex-1 min-w-0">
      <div className="h-4 bg-gray-200 rounded w-24 sm:w-32"></div>
    </div>
    
    {/* Heart Icon Skeleton */}
    <div className="w-4 h-4 bg-gray-200 rounded-full flex-shrink-0"></div>
  </div>
);

const LikesSkeleton = ({ count = 5 }) => {
  return (
    <div className="space-y-2 sm:space-y-3">
      {[...Array(count)].map((_, index) => (
        <LikeItemSkeleton key={index} />
      ))}
    </div>
  );
};

export default LikesSkeleton;